import React from 'react';
import './Calculator.css';

const Home = () => (
  <div>
    <h2>Welcome to our page!</h2>
    <p>
      Lorem ipsum dolor sit amet, consectetur
      adipiscing elit, sed do eiusmod tempor incididunt
      ut labore et dolore magna aliqua.
      Faucibus scelerisque eleifend donec pretium
      vulputate sapien nec sagittis aliquam.
      Eu volutpat odio facilisis mauris sit.
      Lorem ipsum dolor sit amet consectetur adipiscing.
      Nisl purus in mollis nunc sed id semper risus in.
      Volutpat maecenas volutpat blandit
      aliquam etiam erat velit scelerisque.
      Nunc lobortis mattis aliquam faucibus purus in.
      Leo vel orci porta non pulvinar neque.
      Commodo elit at imperdiet dui. Nisi vitae suscipit
      tellus mauris. Tempus urna et pharetra pharetra massa.
      Vitae semper quis lectus nulla at volutpat.
      Et ligula ullamcorper malesuada proin libero nunc consequat.
      Odio facilisis mauris sit amet massa
      vitae tortor condimentum lacinia.
      Nibh sed pulvinar proin gravida hendrerit lectus a.
    </p>
    <p>
      Viverra justo nec ultrices dui sapien eget mi proin.
      Hendrerit gravida rutrum quisque non tellus orci.
      Sit amet facilisis magna etiam tempor.
      Diam vulputate ut pharetra sit amet.
      Molestie at elementum eu facilisis.
      Libero id faucibus nisl tincidunt eget nullam non.
      Amet justo donec enim diam vulputate ut pharetra.
      Dolor sed viverra ipsum nunc aliquet bibendum enim facilisis.
      Magnis dis parturient montes nascetur ridiculus
      mus mauris vitae ultricies.
      Justo eget magna fermentum iaculis eu non diam phasellus.
      Imperdiet sed euismod nisi porta lorem mollis aliquam.
      Nulla pharetra diam sit amet nisl suscipit.
      Viverra ipsum nunc aliquet bibendum. Diam in arcu cursus euismod.
      Feugiat scelerisque varius morbi
      enim nunc faucibus.
      Ullamcorper velit sed ullamcorper morbi tincidunt ornare.
      Ornare quam viverra orci sagittis eu volutpat odio.
    </p>
  </div>
);

export default Home;
